import { siteModel } from 'models/SiteModel';

export default class UserRoleCommentTypeResolver {

  static determineType (model) {

    if (model.get('isFlaggedByUser')) {
      return 'FLAGGED_COMMENT';
    }

    if (model.get('isDeleted')) {
      return UserRoleCommentTypeResolver.determineTypeDeletedComment(model);
    }

    return 'REGULAR_COMENT';
  }

  static determineTypeDeletedComment(model) {
    const isAuthor = () => {
      return siteModel.get('User').isAuthoOf(model);
    };

    if (model.get('isShadow') && isAuthor()) {
      return 'REGULAR_COMENT';
    } else {
      return UserRoleCommentTypeResolver.determineUserType(model);
    }

    return null;
  }

  static determineUserType(model) {
    const User = siteModel.get('User');

    if (User.isModerator() && User.isInModerationMode()) {
      return 'MODERATION_DELETED';
    } else {
      return UserRoleCommentTypeResolver.determineVisibleType(model);
    }
  }

  static determineVisibleType(model) {
    if (model.get('showAsDeleted')) {
      return 'VISIBLE_DELETED';
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-views/user-role-comment-type-resolver.js